
export const ACCESS_TYPE = Object.freeze({
    INTERNAL : 1,
    GOOGLE : 2,
    FACEBOOK : 3
})